import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MaterialService } from '../services/material.service';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../services/alert.service';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router"
import { of } from 'rxjs'
import { SpinnerService } from './../services/spinner.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-material',
  templateUrl: './material.component.html',
  styleUrls: ['./material.component.css']
})
export class MaterialComponent implements OnInit {

  items: any;
  @ViewChild('addMaterial') elMaterial: ElementRef;
  private route: ActivatedRoute;
  id:number;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  reverse: boolean = false;
  CreationDate: Date;
  CreatedBy: string;
  public username;
  
  frmMaterial = new FormGroup({
    Material: new FormControl('', [Validators.required, Validators.minLength(1)])
  });

  config = {
    id: 'Material',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 0,
    totalItems: 0,
  };

  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };

  constructor(private renderer: Renderer2, private _materialservice: MaterialService, private _alertService: AlertService,
    private router: Router,
    public storage: StorageService,
    private spinner: SpinnerService,private authService: MsalService) {
      // const tokenitems = { ...localStorage };
      // if(tokenitems.TokenInfo != undefined) {
      //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
      //     var isAdmin;
      //     var groups;
      //     //console.log('clienttoken');
      //     //console.log(clienttoken);
      //     this.username = clienttoken["unique_name"];
      //     groups = clienttoken["groups"].split(',');

      //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
      //     if(!isAdmin){
      //         this.router.navigate(['/accessdenied']);
      //     }
      // }

  }
  ngOnInit() {
    this.spinner.showSpinner();
    //console.log(this.param);
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.username = activeAccount.username;
    }
    this.GetMaterials();
    this.spinner.hideSpinner();
  }
  SortOder(sortBy){
    if (this.param.SortOrder === "ASC") {
      this.reverse = !this.reverse;
      this.param.SortOrder = "DESC"
    } else{
      this.param.SortOrder = "ASC"
    }
    this.param.SortColumnName = sortBy;
    this.GetMaterials();
  }

  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmMaterial.setValue({Material:""});
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;
    this.spinner.hideSpinner();
  }

  GetMaterials() {
    this._materialservice.getMaterialList(this.param).subscribe((data: any) => {
      //console.log('data');
      //console.log(data);
      var stringified = JSON.stringify(data);
      this.items = JSON.parse(stringified).PagedDataModel;
      this.config.totalItems = JSON.parse(stringified).page.TotalCount;

   });
  }
  pageChanged(event){
    this.config.currentPage = event;
    this.param.PageSelected = event;
    this.GetMaterials();
  }
  EditMaterial(item){
    this.spinner.showSpinner();
    //console.log(item);
    this.id = item.Id;
    this.CreatedBy = item.CreatedBy;
    this.CreationDate = item.CreationDate;
    this.frmMaterial.setValue({
      Material:item.Material1
    });

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);

    this.spinner.hideSpinner();

  }
  AddMaterial(){
    this.spinner.showSpinner();
    this.id = 0;
    this.AddShowHide = false;
    this.EditShowHide = false;
    this.CreateShowHide = true;
    this.UpdateShowHide =false;
    this.CancelShowHide = true;
    this.spinner.hideSpinner();
  }
  Validation(frmM:FormGroup){
    let invalidfield : String = '';

  if (frmM.invalid) {
      Object.keys(frmM.controls).forEach((key) => {
          if(frmM.get(key).invalid == true){

          if (key === "Material") {
            if (invalidfield == '') {
                invalidfield = "Please enter Material" + "<br/>";
            } else {
                invalidfield += "Please enter Material" + "<br/>";
            }
          }
              // if(invalidfield == ''){
              //     invalidfield = "Please enter " +  key.charAt(0).toUpperCase() + key.substr(1).toLowerCase()+ "<br/>";
              // } else {
              //     invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
              // }
          }
      });
      this._alertService.showError(invalidfield);
    }
  }
  CreateMaterial() {
    this.spinner.showSpinner();
    if (this.frmMaterial.invalid) {
      this.Validation(this.frmMaterial);
      this.spinner.hideSpinner();
      return;
    }
    
    let MaterialModel = {
      material1: this.frmMaterial.get('Material').value,
      CreatedBy: this.username,
      CreationDate: new Date(),
      LastModifiedBy: this.username,
      LastModificationDate: new Date()
    }

    let retvalue = this._materialservice.postMaterial(MaterialModel);
    retvalue.pipe(
      catchError(err => {
        this._alertService.showError("Error while creating record");
        return of(null);
      })).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
      this.GetMaterials();
      this.Cancel();
      this._alertService.showSuccess("Record created successfully");
      })
      this.spinner.hideSpinner();
    }

    UpdateMaterial() {
      this.spinner.showSpinner();
      if (this.frmMaterial.invalid) {
        this.Validation(this.frmMaterial);
        this.spinner.hideSpinner();
        return;
      }

      let MaterialModel = {
        id: this.id,
        Material1: this.frmMaterial.get('Material').value,
        LastModifiedBy: this.username,
        LastModificationDate: new Date(),
        CreationDate: this.CreationDate,
        CreatedBy: this.CreatedBy

      }

      let retvalue = this._materialservice.putMaterial(MaterialModel);

      retvalue.pipe(
        catchError(err => {
          alert("Error while creating record!!!");
          return of(null);
        })).subscribe((value: any) => {
          this.param.SortOrder = "DESC";
          this.GetMaterials();
          this.Cancel();
          setTimeout("",1000);
          this._alertService.showSuccess("Record updated successfully");
        })

        this.spinner.hideSpinner();
  }

  //delete material
  DeleteMaterial(materialId: number) {
    if (confirm('Are you sure to delete this record ?')) {
      this._materialservice.deleteMaterial(materialId).subscribe(
        (data: any) => {
          this._alertService.showSuccess("Deleted successfully");
        },
        err => {
          if (err.status == 400)
            this._alertService.showError("No data exists");
          else
            this._alertService.showError("Bad request");
        }
      );
      this.GetMaterials();
    }
  }
  
  }
